export default {
    url: '/skill',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/user/competence/skill/index.js